import { _ as ft } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.some-0c761b6d.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import "./es.object.to-string-f55666a8.js";
import { c as Re } from "./index-8b07dec9.js";
import { useRef as z, useState as fe, useEffect as K, forwardRef as Dt, useLayoutEffect as gt } from "react";
import ne, { css as Je } from "styled-components";
import "@ucl/shared-component-foundations";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as Ct } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as yt } from "./useWindowSize.js";
import "./carousel.js";
import "./index-5d0f31c6.js";
import { jsx as y, jsxs as Ve } from "react/jsx-runtime";
import { InputState as re, HelperText as St } from "./helperText.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./index-f5b44da3.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { ScreenReaderOnly as kt } from "./screenReaderOnly.js";
import { useAccessibilityProps as Pt } from "./accessibility.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import { uniqueId as wt } from "./uniqueId.js";
import { g as Ge } from "./getElementPosition-8d0dbc61.js";
import { u as Ot, a as xt, H as bt, M as Mt, Y as Tt, D as Nt } from "./index-7e2f9db6.js";
import { s as j, g as Fe, d as Ze, b as We, T as et, e as Et, v as Yt, h as Qe } from "./localeLanguages-75ceae62.js";
import { C as Lt } from "./CalendarPickerInput-55c0d122.js";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./array-method-is-strict-e5a3c878.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./combineRefs-c9ad2c39.js";
import "./useMediaQuery.js";
import "./iconButton.js";
import "./button.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./aria.js";
import "./popupTip-06ee114c.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./tooltip.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.symbol.description-6025a604.js";
import "./es.string.search-d27ec57a.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./index-f2264f1e.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./es.global-this-a7f40ce1.js";
import "./badge.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "./index-ebdb31f7.js";
var Rt = /* @__PURE__ */ ne.div.withConfig({
  displayName: "Calendar__StyledCalendar",
  componentId: "sc-1c62kff-0"
})(["&.Calendar{", ";}"], function(e) {
  var a = e.theme.components.datePicker;
  return a.StyledCalendar;
}), Ft = /* @__PURE__ */ ne.div.withConfig({
  displayName: "Calendar__StyledCalendarWeekDays",
  componentId: "sc-1c62kff-1"
})(["&.Calendar__weekDays{", ";}"], function(e) {
  var a = e.theme.components.datePicker;
  return a.StyledCalendarWeekDays;
}), Wt = /* @__PURE__ */ ne.abbr.withConfig({
  displayName: "Calendar__StyledCalendarWeekDay",
  componentId: "sc-1c62kff-2"
})(["&.Calendar__weekDay{", ";}"], function(e) {
  var a = e.theme.components.datePicker;
  return a.StyledCalendarWeekDay;
}), At = function(a, i) {
  for (var c = new Date(a.year, a.month - 1, a.day), v = new Date(i.year, i.month - 1, i.day), L = []; c <= v; )
    L.push({
      year: c.getFullYear(),
      month: c.getMonth() + 1,
      day: c.getDate()
    }), c.setDate(c.getDate() + 1);
  return L;
}, Le = function(a) {
  if (!a)
    return null;
  var i = [];
  return a.forEach(function(c) {
    "from" in c && "to" in c ? i.push.apply(i, At(c.from, c.to)) : i.push(c);
  }), i;
}, Bt = function(a) {
  var i = a.value, c = a.onChange, v = a.onDisabledDayError, L = a.calendarClassName, X = a.calendarTodayClassName, M = a.calendarSelectedDayClassName, De = a.disabledDays, R = a.minimumDate, ie = a.maximumDate, S = a.selectorStartingYear, T = a.selectorEndingYear, N = a.locale, ge = a.shouldHighlightWeekends, Ce = a.customDaysClassName, ye = a.includeOutOfMonthDays, E = a.allowedDates, P = a.weekendDisabled, G = a.textMarkers, F = z(null), Q = fe({
    activeDate: {},
    monthChangeDirection: "",
    isMonthSelectorOpen: !1,
    isYearSelectorOpen: !1
  }), o = Q[0], Y = Q[1], J = fe(), l = J[0], V = J[1], Se = function(n) {
    var s = Le(n), f = [];
    s == null || s.forEach(function(A) {
      return f.push(new Date(A.year, A.month - 1, A.day).getTime());
    });
    var D = new Date(Math.min.apply(Math, f)), w = new Date(Math.max.apply(Math, f));
    V({
      minDate: {
        year: D.getFullYear(),
        month: D.getMonth() + 1,
        day: D.getDate()
      },
      maxDate: {
        year: w.getFullYear(),
        month: w.getMonth() + 1,
        day: w.getDate()
      }
    });
  };
  K(function() {
    E ? Se(E) : V({
      minDate: R,
      maxDate: ie
    });
  }, [R, ie, E]), K(function() {
    var m, n = function(f) {
      var D;
      f.code === "Tab" && (F == null || (D = F.current) == null || D.classList.remove("-noFocusOutline"));
    };
    return (m = F.current) == null || m.addEventListener("keyup", function() {
      return n;
    }, !1), function() {
      var s;
      (s = F.current) == null || s.removeEventListener("keyup", function() {
        return n;
      }, !1);
    };
  });
  var ke = Ot(N), Z = ke.getToday, ee = xt(N), Pe = ee.weekDays, oe = ee.isRtl, I = Z(), te = function(n) {
    return function() {
      var s;
      Y(Object.assign({}, o, (s = {}, s[n] = !o[n], s)));
    };
  }, le = te("isMonthSelectorOpen"), we = te("isYearSelectorOpen"), se = function() {
    var n = Fe(i);
    if (n === Ze && i.length)
      return j(i[0]);
    if (n === We && i)
      return j(i);
    if (n === et && i.from)
      return j(i.from);
    if (!i) {
      if (E) {
        var s = Le(E), f = [];
        s == null || s.forEach(function(w) {
          return f.push(new Date(w.year, w.month - 1, w.day).getTime());
        });
        var D = new Date(Math.min.apply(Math, f));
        return {
          year: D.getFullYear(),
          month: D.getMonth() + 1,
          day: D.getDate()
        };
      }
      if (R)
        return j(R);
      if (S && S > I.year)
        return {
          year: S,
          month: 1,
          day: 1
        };
      if (T && T < I.year)
        return S ? {
          year: S,
          month: 1,
          day: 1
        } : {
          year: T,
          month: 1,
          day: 1
        };
    }
    return j(I);
  }, k = Object.keys(o.activeDate).length > 0 ? j(o.activeDate) : se(), Oe = Pe.map(function(m) {
    return /* @__PURE__ */ y(Wt, {
      title: m.name,
      className: "Calendar__weekDay",
      children: m.short
    }, m.name);
  }), ue = function(n) {
    Y(Object.assign({}, o, {
      monthChangeDirection: n
    }));
  }, W = function() {
    Y(Object.assign({}, o, {
      activeDate: Et(k, o.monthChangeDirection),
      monthChangeDirection: ""
    }));
  }, ce = function(n) {
    var s = document.querySelector(n);
    s && setTimeout(function() {
      s.focus();
    }, 100);
  }, xe = function(n) {
    Y(Object.assign({}, o, {
      activeDate: Object.assign({}, k, {
        month: n
      }),
      isMonthSelectorOpen: !1
    })), ce(".Calendar__monthText");
  }, U = function(n) {
    Y(Object.assign({}, o, {
      activeDate: Object.assign({}, k, {
        year: n
      }),
      isYearSelectorOpen: !1
    })), ce(".Calendar__yearText");
  };
  return /* @__PURE__ */ Ve(Rt, {
    className: Re(["Calendar", L, "-" + (oe ? "rtl" : "ltr")]),
    role: "grid",
    ref: F,
    children: [/* @__PURE__ */ y(bt, {
      maximumDate: l == null ? void 0 : l.maxDate,
      minimumDate: l == null ? void 0 : l.minDate,
      activeDate: k,
      onMonthChange: ue,
      onMonthSelect: le,
      onYearSelect: we,
      monthChangeDirection: o.monthChangeDirection,
      isMonthSelectorOpen: o.isMonthSelectorOpen,
      isYearSelectorOpen: o.isYearSelectorOpen,
      locale: N,
      selectorStartingYear: S,
      selectorEndingYear: T
    }), /* @__PURE__ */ y(Mt, {
      isOpen: o.isMonthSelectorOpen,
      activeDate: k,
      onMonthSelect: xe,
      maximumDate: l == null ? void 0 : l.maxDate,
      minimumDate: l == null ? void 0 : l.minDate,
      locale: N
    }), /* @__PURE__ */ y(Tt, {
      isOpen: o.isYearSelectorOpen,
      activeDate: k,
      onYearSelect: U,
      selectorStartingYear: S,
      selectorEndingYear: T,
      maximumDate: l == null ? void 0 : l.maxDate,
      minimumDate: l == null ? void 0 : l.minDate,
      locale: N
    }), /* @__PURE__ */ y(Ft, {
      className: "Calendar__weekDays",
      children: Oe
    }), /* @__PURE__ */ y(Nt, {
      activeDate: k,
      value: i,
      selectorStartingYear: S,
      selectorEndingYear: T,
      monthChangeDirection: o.monthChangeDirection,
      onSlideChange: W,
      disabledDays: De,
      onDisabledDayError: v,
      minimumDate: l == null ? void 0 : l.minDate,
      maximumDate: l == null ? void 0 : l.maxDate,
      onChange: c,
      calendarTodayClassName: X,
      calendarSelectedDayClassName: M,
      locale: N,
      shouldHighlightWeekends: ge,
      customDaysClassName: Ce,
      includeOutOfMonthDays: ye,
      isQuickSelectorOpen: o.isYearSelectorOpen || o.isMonthSelectorOpen,
      allowedDates: Le(E),
      weekendDisabled: P,
      textMarkers: G
    })]
  });
}, $t = ["value", "isDisabled", "onChange", "formatInputText", "autoSelect", "inputPlaceholder", "inputClassName", "inputName", "wrapperClassName", "calendarClassName", "calendarTodayClassName", "calendarSelectedDayClassName", "calendarPopperPosition", "disabledDays", "onDisabledDayError", "minimumDate", "maximumDate", "selectorStartingYear", "selectorEndingYear", "locale", "shouldHighlightWeekends", "customDaysClassName", "dateFormatOptions", "fullwidth", "isRequired", "textSize", "includeOutOfMonthDays", "onBlur", "accessibilityOptions", "labelProp", "infoProp", "trailingText", "allowedDates", "weekendDisabled", "exceedOverflow", "editable", "inputState", "helperTextProp", "hideClearButton", "textMarkers"], Ht = "CalendarInput", It = `
  @keyframes fadeCalendar {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeArrowFlipped {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
      transform: translateY(0) rotate(180deg);
    }
  }

  @keyframes fadeTextToCenter {
    to {
      opacity: 1;
      transform: translateX(-50%);
    }
  }

  @keyframes FadeContentToCenter {
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`, Ut = /* @__PURE__ */ ne.div.withConfig({
  displayName: "datePicker__StyledDatePickerWrapper",
  componentId: "sc-1mom15t-0"
})(["&.DatePicker{", ";", ";}"], function(e) {
  var a = e.theme.components.datePicker;
  return Je(a.StyledDatePickerWrapper);
}, It), qt = /* @__PURE__ */ ne.div.withConfig({
  displayName: "datePicker__StyledDatePickerCalenderContainer",
  componentId: "sc-1mom15t-1"
})(["&.DatePicker__calendarContainer{", ";}"], function(e) {
  var a = e.theme.components.datePicker;
  return Je(a.StyledDatePickerCalenderContainer);
}), tn = /* @__PURE__ */ Dt(function(e, a) {
  var i, c, v = e.value, L = e.isDisabled, X = L === void 0 ? !1 : L, M = e.onChange, De = e.formatInputText, R = e.autoSelect, ie = R === void 0 ? !0 : R, S = e.inputPlaceholder, T = e.inputClassName, N = e.inputName, ge = e.wrapperClassName, Ce = e.calendarClassName, ye = e.calendarTodayClassName, E = e.calendarSelectedDayClassName, P = e.calendarPopperPosition, G = e.disabledDays, F = e.onDisabledDayError, Q = e.minimumDate, o = e.maximumDate, Y = e.selectorStartingYear, J = e.selectorEndingYear, l = e.locale, V = l === void 0 ? "en-US" : l, Se = e.shouldHighlightWeekends, ke = e.customDaysClassName, Z = e.dateFormatOptions, ee = e.fullwidth, Pe = ee === void 0 ? !1 : ee, oe = e.isRequired, I = oe === void 0 ? !1 : oe, te = e.textSize, le = e.includeOutOfMonthDays, we = le === void 0 ? !0 : le, se = e.onBlur, k = e.accessibilityOptions, Oe = k === void 0 ? {} : k, ue = e.labelProp, W = ue === void 0 ? {} : ue, ce = e.infoProp, xe = e.trailingText, U = e.allowedDates, m = e.weekendDisabled, n = m === void 0 ? !1 : m, s = e.exceedOverflow, f = s === void 0 ? !1 : s, D = e.editable, w = D === void 0 ? !1 : D, A = e.inputState, Ae = e.helperTextProp, Be = Ae === void 0 ? {} : Ae, $e = e.hideClearButton, tt = $e === void 0 ? !1 : $e, at = e.textMarkers, rt = ft(e, $t), be = z(null), nt = Ct({
    label: "DatePicker"
  }), O = z(null), x = z(null), Me = z(wt(Ht)), B = z(!1), He = fe(!1), d = He[0], b = He[1], Ie = fe({}), it = Ie[0], Ue = Ie[1], qe = yt(), ot = qe.width, lt = qe.height, Te = v;
  typeof v == "string" && (Te = Yt(v, !0) || "");
  var me = A || re.NONE, g = Be;
  g && (g.defaultProp && !g.defaultProp.id && (g.defaultProp.id = "default_" + Me.current + "_message_id"), g.secondaryProp && !g.secondaryProp.id && (g.secondaryProp.id = "secondary_" + Me.current + "_message_id"));
  var st = function(t) {
    x.current = t, typeof a == "function" ? a(t) : a && typeof a == "object" && (a.current = t);
  };
  K(function() {
    var r, t = Fe(v);
    if (t !== Ze) {
      var p = t === We ? !d : !d && (v == null ? void 0 : v.from) && (v == null ? void 0 : v.to);
      p && (x == null || (r = x.current) == null || r.blur());
    }
  }, [v, d]);
  var ut = function(t) {
    var p;
    if (t.persist(), !!d) {
      var q = (p = O.current) == null ? void 0 : p.contains(t.relatedTarget);
      if (B.current) {
        var $;
        B.current = !1, x == null || ($ = x.current) == null || $.focus();
      } else
        q && t.relatedTarget && t.relatedTarget.focus();
      se && se(t);
    }
  }, ct = function() {
    B.current || b(!0);
  }, mt = function(t) {
    var p = function(u, h) {
      if (!u || !h)
        return !1;
      if (Object.keys(h).length === 2) {
        var he, _e, je, ze, Ke, Xe, C = h;
        return u.day >= ((C == null || (he = C.from) == null ? void 0 : he.day) || 0) && u.month >= ((C == null || (_e = C.from) == null ? void 0 : _e.month) || 0) && u.year >= ((C == null || (je = C.from) == null ? void 0 : je.year) || 0) && u.day <= ((C == null || (ze = C.to) == null ? void 0 : ze.day) || 0) && u.month <= ((C == null || (Ke = C.to) == null ? void 0 : Ke.month) || 0) && u.year <= ((C == null || (Xe = C.to) == null ? void 0 : Xe.year) || 0);
      }
      return u.day === (h == null ? void 0 : h.day) && u.month === (h == null ? void 0 : h.month) && u.year === (h == null ? void 0 : h.year);
    }, q = function(u, h) {
      return !u || !h ? !1 : $(u) < $(h);
    }, $ = function(u) {
      return new Date(u.year, u.month - 1, u.day);
    }, ae = !1;
    U && U.some(function(H) {
      return p(t, H);
    }) && (ae = !0);
    var de = q(t, Q), Ne = q(o, t), pe = ((t == null ? void 0 : t.year) || 0) < Y || ((t == null ? void 0 : t.year) || 0) > J, ve = G == null ? void 0 : G.some(function(H) {
      return p(t, H);
    }), Ee = de || Ne || pe, Ye = [0, 6].includes(new Date((t == null ? void 0 : t.year) || 0, ((t == null ? void 0 : t.month) || 1) - 1, t == null ? void 0 : t.day).getDay()), _ = U ? !ae : ve || Ee || Ye && n;
    _ || M == null || M(t, Qe(t, Z)), t === void 0 && (M == null || M(t, {
      formatted: "",
      default: "",
      native: null
    }));
  };
  gt(function() {
    if (d && O.current) {
      var r = O.current.getBoundingClientRect(), t = r.left, p = r.width, q = r.height, $ = r.top, ae = document.documentElement, de = ae.clientWidth, Ne = ae.clientHeight, pe = t + p > de, ve = t < 0, Ee = $ + q > Ne, Ye = function() {
        var u = t + p - de;
        if (!pe && !ve)
          return "";
        var h = Math.abs(t), he = ve ? h : 0;
        return pe ? "calc(50% - " + u + "px)" : "calc(50% + " + he + "px)";
      };
      if (O.current.style.left = Ye(), P === "auto" && Ee || P === "top") {
        var _;
        O == null || (_ = O.current) == null || (_ = _.classList) == null || _.add("-top");
      }
    }
  }, [P, d]);
  var dt = function(t) {
    var p = Fe(t);
    M && M(t, Qe(t, Z)), (p === We || p === et && t != null && t.to) && b(!1);
  }, pt = function(t) {
    switch (t.code) {
      case "Enter":
        b(!v);
        break;
      case "Escape":
        b(!1), B.current = !0;
        break;
    }
  };
  K(function() {
    if (!d && B.current) {
      var r;
      x == null || (r = x.current) == null || r.focus(), B.current = !1;
    }
  }, [B, d]);
  var vt = Pt("input", Object.assign({
    ariaDisabled: X,
    ariaInvalid: me === re.ERROR || me === re.CAUTION,
    ariaRequired: I,
    ariaLabel: "MM / DD /YY"
  }, Oe));
  K(function() {
    if (d && f) {
      var r = P === "auto" || !P ? "bottom" : P;
      Ue(Object.assign({}, Ge(x, O, r, "datepicker"), {
        left: "unset"
      }));
      var t = function() {
        Ue(Object.assign({}, Ge(x, O, r, "datepicker"), {
          left: "unset"
        }));
      };
      return window.addEventListener("scroll", t, !0), function() {
        window.removeEventListener("scroll", t, !0);
      };
    }
  }, [d, f, ot, lt, P]), K(function() {
    var r = function(p) {
      be.current && !be.current.contains(p.target) && d && b(!1);
    };
    return window.addEventListener("click", r), window.addEventListener("keyup", r), function() {
      window.removeEventListener("click", r), window.removeEventListener("keyup", r);
    };
  }, [d]);
  var ht = function() {
    b(!d);
  };
  return /* @__PURE__ */ Ve(Ut, Object.assign({
    ref: be,
    onFocus: ct,
    onBlur: ut,
    onKeyUp: pt,
    className: Re(["DatePicker", ge, "DatePicker--" + te, {
      "DatePicker--fullwidth": Pe
    }, {
      "DatePicker--hasHelper": !!Be && d
    }]),
    role: "presentation"
  }, nt, {
    children: [/* @__PURE__ */ y(Lt, Object.assign({
      ref: st,
      isDisabled: X,
      formatInputText: De,
      closeCalendar: ht,
      value: Te,
      editable: w,
      onChange: mt,
      autoSelect: ie,
      inputPlaceholder: S,
      inputLabel: W == null ? void 0 : W.label,
      success: A === re.SUCCESS,
      showRequiredIndicator: W == null ? void 0 : W.showRequiredIndicator,
      inputClassName: T,
      inputName: N,
      locale: V,
      dateFormatOptions: Z,
      inputId: Me.current,
      showErrorIcon: !d && A === re.ERROR,
      isRequired: I,
      textSize: te,
      labelProp: Object.assign({}, W),
      infoProp: Object.assign({}, ce),
      trailingText: xe,
      helperTextProp: d ? {
        defaultProp: {
          id: g == null || (i = g.defaultProp) == null ? void 0 : i.id
        },
        secondaryProp: {
          id: g == null || (c = g.secondaryProp) == null ? void 0 : c.id
        }
      } : g,
      inputState: me,
      hideClearButton: tt
    }, vt, rt)), /* @__PURE__ */ y(kt, {
      "aria-live": "assertive",
      id: "hidden_message_id",
      children: /* @__PURE__ */ y(St, Object.assign({}, g, {
        inputState: me
      }))
    }), d && !X && /* @__PURE__ */ y(qt, {
      ref: O,
      className: Re(["DatePicker__calendarContainer", {
        "DatePicker__calendarContainer--exceedOverflow": f
      }]),
      "data-testid": "calendar-container",
      role: "presentation",
      style: f ? it : {},
      children: /* @__PURE__ */ y(Bt, {
        value: Te,
        onChange: dt,
        calendarClassName: Ce,
        calendarTodayClassName: ye,
        calendarSelectedDayClassName: E,
        disabledDays: G,
        onDisabledDayError: F,
        minimumDate: Q,
        maximumDate: o,
        selectorStartingYear: Y,
        selectorEndingYear: J,
        locale: V,
        shouldHighlightWeekends: Se,
        customDaysClassName: ke,
        includeOutOfMonthDays: we,
        allowedDates: U,
        weekendDisabled: n,
        textMarkers: at
      })
    })]
  }));
});
export {
  tn as DatePicker
};
